import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Grid, Row, Col } from "react-bootstrap";
import ContactForm from "./ContactForm";
import Notification from "./Notification";
import { PageHeader, Nav, NavItem } from "react-bootstrap";

import "./App.css";

class App extends Component {
  state = {
    show: false,
    type: "warning",
    header: "",
    text: "",
    timer: null
  };

  createNotification(type, header, text) {
    this.setState({
      show: true,
      type: type,
      header: header,
      text: text
    });
    const timer = setTimeout(() => {
      this.setState({ show: false });
    }, 3000);
    this.setState({ timer: timer });
  }

  handleStatusChange() {
    const { timer } = this.state;
    clearTimeout(timer);
    this.setState({ show: false });
  }

  createNotification = this.createNotification.bind(this);
  handleStatusChange = this.handleStatusChange.bind(this);

  render() {
    return (
      <div>
        <Grid fluid>
          <Row>
            <Col mdOffset={3} md={6}>
              <div>
                <Nav pullRight bsStyle="pills" activeKey={this.props.i18n.language} onSelect={(key) => this.props.i18n.changeLanguage(key)}>
                  <NavItem eventKey="en">Eng</NavItem>
                  <NavItem eventKey="ru">Рус</NavItem>
                </Nav>
                <PageHeader className="App-header">
                  {this.props.t('title')}
                </PageHeader>
                <div style={{clear: 'both'}} />
              </div>
              <ContactForm createNotification={this.createNotification} />
            </Col>
          </Row>
        </Grid>
        <Notification
          {...this.state}
          handleStatusChange={this.handleStatusChange}
        />
        <p />
      </div>
    );
  }
}

export default withTranslation()(App);



// WEBPACK FOOTER //
// ./src/containers/App.js